import { render, staticRenderFns } from "./login-link.vue?vue&type=template&id=beb65f7e&scoped=true&"
import script from "./login-link.vue?vue&type=script&lang=js&"
export * from "./login-link.vue?vue&type=script&lang=js&"
import style0 from "./login-link.vue?vue&type=style&index=0&id=beb65f7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb65f7e",
  null
  
)

export default component.exports